<template>
  <div :class="$style.record">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>活动规则</p>
    </header>
    <div v-if="receive_info.rule_text" style="white-space: pre-wrap;">{{ receive_info.rule_text }}</div>
    <div v-else>
      <p>1、该红包活动仅对本包新注册用户开放，非本包注册用户、非新注册用户均不能参与红包活动</p>
      <p>2、用户可以通过完成任务并领取红包获得红包余额，余额会根据红包类型储存到钱包余额中，玩家可以在【我的钱包】中查看不同种类的红包余额，并可以发起提现申请</p>
      <p>3、玩家可以在微信和支付宝两种方式二选一进行提现，无论选择哪种方式均需要绑定玩家本人的微信或者支付宝。可以在提现页面点击【提现攻略】查看具体绑定流程，微信和支付宝均未绑定则无法正常提现</p>
      <p>4、成功发起提现后进入审核，金额较大的提现会需要较长时间，我们会尽快审核，请耐心等待！审核完成后会通过支付宝转账或者微信红包的方式下发</p>
      <p>5、如果提现申请未通过审核，则会将余额返还到红包余额中，重新发起提现申请即可。如果多次审核均未通过，可联系客服查询未通过审核的具体原因</p>
      <p>6、不同种类的红包有不同的提现档位，部分档位有提现次数限制，次数佣金后无法发起该档位的提现申请</p>
      <p>7、凡使用作弊手段或利用游戏漏洞达成活动条件的多玩家将取消领奖资格，本活动解释权在法律允许范围内归本公司所有，详情见免责声明</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: '',
  data () {
    return {
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      receive_info: (state) => state.redEnvelope.receive_info
    }),
  },
  methods: {
    back() {
      this.$emit('setPage', 'receive');
    },
  }
}
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.record {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  overflow: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    margin-bottom: 30px;
    padding: 12px 0 24px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/condition_back.png');
    background-size: 100% 100%;
    color: #FFFFFF;
    > .back {
      position: absolute;
      left: 22px;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 10px { top: 0; left: 0 };
    }
  }
  > div {
    padding: 0 10px 10px;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 2px;
    p {
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 2px;
    }
  }
}
</style>  